import { useMutation, useQueryClient } from "@tanstack/react-query";
import { erp } from "@/lib/erp";
import { useNavigate } from "react-router-dom";
import { routes } from "@/lib/config/routes";
import { toast } from "sonner";

/**
 * Hook for deleting an item
 *
 * @param name - Item name/code to delete
 * @returns React Query mutation for deleting item
 */
export function useDeleteItem(name: string) {
  const queryClient = useQueryClient();
  const navigate = useNavigate();

  return useMutation<void, Error, void>({
    mutationFn: () => {
      return erp.items.delete(name);
    },
    onSuccess: () => {
      // Invalidate both detail and list queries
      queryClient.invalidateQueries({ queryKey: ["item", name] });
      queryClient.invalidateQueries({ queryKey: ["items", "list"] });
      toast.success("Item deleted successfully");
      // Redirect to list page using route config
      navigate(routes.item.list);
    },
    onError: (error) => {
      toast.error(error.message || "Failed to delete item");
    },
  });
}

